export default "__VITE_ASSET__db2bc53c__"